import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CommonLocale } from "@/locales/localeid";
import LabelText from "@/components/label-text/label-text.vue";
import { fmtMsg } from "commonui";
import { MethodologyTypeItems, MethodologyTypeItemsWithAll } from "@/util/constants";
import { MethodologyType } from "@/util/enum";

@Component({
	components: {
		"a-select": Select,
		"a-select-option": Select.Option,
		LabelText
	}
})
export default class MethodologySelect extends Vue {
	@Prop({ default: true }) displayLabel!: boolean;
	@Prop({ default: false }) includeAllItem!: boolean;
	@Prop({ default: false }) includeOnlyREP!: boolean;
	@Prop({ default: true }) includeREP!: boolean;
	@Prop() value!: number;
	@Prop() disabled!: boolean;

	get methodology(): string {
		return fmtMsg(CommonLocale.CommonFieldMethodology);
	}

	get methodologyItems(): Map<number, string> {
		return this.includeOnlyREP ? new Map([...MethodologyTypeItems].filter((k,v) => v === MethodologyType.REP)): 
		this.includeAllItem ? MethodologyTypeItemsWithAll : 
		this.includeREP ? MethodologyTypeItems: new Map([...MethodologyTypeItems].filter((k,v) => v !== MethodologyType.REP));
	}

	onMethodologyChanged(changedValue: number): void {
		this.$emit("change", changedValue);
	}
}
